import {
  getInvalidFileTypeMessage,
  uploadFileErrorMessage
} from "common/consts/uploadFileErrors";
import Modal from "components/modal/Modal";
import ModalFooter from "components/modal/ModalFooter";
import { usePermission } from "hooks/use-permissions";

import "./FileUploadErrorModal.scss";

export type Props = {
  failMessage: string;
  setFailed: (failed: boolean) => void;
};

export default function FileUploadErrorModal({ failMessage, setFailed }: Props) {
  const isInternal = usePermission("isInternal");
  const errorMessage = uploadFileErrorMessage[failMessage];
  const message =
    failMessage === "INVALID_FILE_TYPE"
      ? getInvalidFileTypeMessage(isInternal)
      : errorMessage.message;

  return (
    <Modal
      size="xs"
      onDismiss={() => setFailed(false)}
      modalTitle="upload failed"
      header={<h1 className="m-0">{errorMessage.title}</h1>}
      footer={
        <ModalFooter
          hideCancel
          onConfirm={() => setFailed(false)}
          confirmText="Fortsätt"
          justifyActions="end"
        />
      }
    >
      <p className="file-error-message">{message}</p>
    </Modal>
  );
}
